import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useOrg } from '../context/OrgContext';
import './ChannelCard.css';

function ChannelCard({ channel }) {
  const navigate = useNavigate();
  const { isOrgUser, orgSlug } = useOrg();
  const params = useParams();
  const slug = params.slug || orgSlug;

  const handleClick = () => {
    const path = (isOrgUser && slug)
      ? `/org/${slug}/channels/${channel.channel_id}`
      : `/channels/${channel.channel_id}`;
    navigate(path);
  };

  const orgColor = channel.org_brand_color || '#7C3AED';

  return (
    <div className="channel-card" onClick={handleClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleClick()}>
      {channel.new_post_count > 0 && (
        <span className="channel-card-badge">{channel.new_post_count}</span>
      )}
      <span className="channel-card-icon">{channel.category_icon || '💬'}</span>
      <span className="channel-card-name">{channel.name}</span>
      {channel.is_org_channel && channel.org_name && (
        <span className="channel-card-org" style={{ color: orgColor }}>
          <span
            className="channel-card-org-dot"
            style={{ backgroundColor: orgColor }}
            aria-hidden="true"
          />
          {channel.org_name}
        </span>
      )}
      <span className="channel-card-meta">
        {typeof channel.member_count === 'string' ? channel.member_count : `${channel.member_count} members`}
      </span>
    </div>
  );
}

export default ChannelCard;
